var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsituteBtmImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9643 0H28.8658C29.5013 0 30.0176 0.635459 30.0176 1.15179V3.36708C30.0176 4.00254 29.5013 4.51887 28.8658 4.51887H11.9643C11.3288 4.51887 10.8125 3.88342 10.8125 3.36708V1.15179C10.8125 0.516331 11.3288 0 11.9643 0Z",
    fill: "#01A9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.913 26.548L29.433 23.7458C28.7159 22.9382 28.3254 21.899 28.3254 20.82V18.6444H19.8526C19.2304 18.6444 18.7229 18.1369 18.7229 17.5147C18.7229 16.8925 19.2304 16.385 19.8526 16.385H28.3254V12.4311H22.112C21.4898 12.4311 20.9823 11.9236 20.9823 11.3014C20.9823 10.6791 21.4898 10.1716 22.112 10.1716H28.3254V5.65283H12.5095V20.8202C12.5095 21.8992 12.1146 22.9384 11.4019 23.746L8.92188 26.5482L31.913 26.548Z",
    fill: "#01A9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9034 28.8074H6.92721L1.25666 35.2235C-0.0583737 36.7085 -0.365089 38.7539 0.449089 40.5675C1.26327 42.3746 3.00194 43.4999 4.98553 43.4999H35.8496C37.8332 43.4999 39.5719 42.3768 40.3861 40.5675C41.2002 38.7605 40.8935 36.7151 39.5785 35.2235L33.9079 28.8074H33.9034Z",
    fill: "#01A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsituteBtmImg2);
export default __webpack_public_path__ + "static/media/insituteBtmImg2.42ad747c3803600f59b6ab85260d431c.svg";
export { ForwardRef as ReactComponent };